<template>
    <div v-if="$root.admin_auth">
        <div class="topbar">
            <div class="menu">
                <img :src="base_url + '/admin/img/menu.svg'" />
            </div>
            <div class="logo">
                <img :src="base_url + '/admin/img/logo.svg'" />
            </div>
            <div class="search" v-bind:class="{ 'show-result': emptyState }">
                <input type="text" class="form-control" v-model="search" placeholder="Search for Employees" @keyup="searchEmployee" />
                <div class="search__result">
                    <div class="search__scrollablearea">
                        <div v-for="result in searchResult">
                            <router-link class="search__user" :to="'/employees/' + result.id">
                                <img :src="result.image" />
                                <div class="search__details">
                                    <h5>{{ result.full_name }}</h5>
                                    <p>{{ result.phone }}</p>
                                </div>
                            </router-link>
                        </div>  
                    </div>
                    <!-- <a class="search__advanced" href="#">Advanced Search</a> -->
                </div>
            </div>
            <div class="login-user d-flex align-items-center">
                <div class="notificationContainer me-3">
                    <div class="notificationBell" v-bind:class="{'active': newNotificatins}">
                        <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="bell" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="svg-inline--fa bellIcon fa-bell fa-w-14 fa-7x">
                            <path fill="currentColor" d="M224 512c35.32 0 63.97-28.65 63.97-64H160.03c0 35.35 28.65 64 63.97 64zm215.39-149.71c-19.32-20.76-55.47-51.99-55.47-154.29 0-77.7-54.48-139.9-127.94-155.16V32c0-17.67-14.32-32-31.98-32s-31.98 14.33-31.98 32v20.84C118.56 68.1 64.08 130.3 64.08 208c0 102.3-36.15 133.53-55.47 154.29-6 6.45-8.66 14.16-8.61 21.71.11 16.4 12.98 32 32.1 32h383.8c19.12 0 32-15.6 32.1-32 .05-7.55-2.61-15.27-8.61-21.71z" class=""></path>
                        </svg>
                    </div>
                    <div class="notificationDropdownContainer d-none">
                        <ul class="notificationList">
                            <li v-for="notification in notifications">
                                <a href="javascript:;" v-bind:class="{'unread': !notification.viewed}">
                                    {{ notification.employee_organization.first_name }}
                                    {{ notification.employee_organization.last_name }}
                                    ({{ notification.location.name }})
                                    <br />
                                    {{ notification.action_date }}
                                    {{ notification.action_time }}
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="login-user__preview">
                    <img class="login-user__img" :src="getProfileImage($root.adminInfo)" />
                    <h6>{{ $root.adminInfo.first_name }} {{ $root.adminInfo.last_name }}</h6>
                    <div class="dropdown">
                        <img class="menu-icon" :src="base_url + '/admin/img/menu-icon.svg'" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" />
                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                            <a class="dropdown-item" href="#" @click.prevent="editCurrentAdmin">Edit Profile</a>
                            <a class="dropdown-item" href="#" @click.prevent="adminLogout">Logout</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade" id="manageCurrentAdminModalUpdate" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Update Admin</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <form-error :errors="errors"></form-error>
                    <form action="#" id="manageAdminFormUpdate" @submit.prevent="updateCurrentAdmin">
                        <div class="modal-body">
                            <div class="form-group">
                                <label for="">Uploaded Image</label>
                                <img :src="authenticatedAdmin.image" class="w-25" />
                            </div>
                            <div class="form-group">
                                <label for="">Upload new image</label>
                                <input type="file" class="form-control" name="image" />
                            </div>
                            <div class="form-group">
                                <label for="">First Name</label>
                                <input type="text" class="form-control" name="first_name" v-model="authenticatedAdmin.first_name" required />
                            </div>
                            <div class="form-group">
                                <label for="">Last Name</label>
                                <input type="text" class="form-control" name="last_name" v-model="authenticatedAdmin.last_name" required />
                            </div>
                            <div class="form-group">
                                <label for="">Email ID</label>
                                <input type="email" class="form-control" name="email" v-model="authenticatedAdmin.email" required readonly="" />
                            </div>
                            <div class="form-group">
                                <label for="">Phone Number</label>
                                <input type="text" class="form-control" name="phone" v-model="authenticatedAdmin.phone" required />
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="submit" class="btn btn-primary">Save</button>
                            <button type="button" class="btn" data-bs-dismiss="modal">Cancel</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import FormError from './FormError.vue';
export default {
    data() {
        return {
            search: "",
            searchResult: {},
            emptyState: false,
            admin_id: null,
            authenticatedAdmin: new Form({
                first_name: '',
                last_name: '',
                email: '',
                phone: '',
                image: ""
            }),
            notifications: {},
            newNotificatins: false,
            errors: false
        }
    },
    mounted() {
        this.loadNotifications();
    },
    methods: {
        loadNotifications() {
            axios.get(`/api/admin/notifications`).then(response => {
                this.notifications = response.data.data.records;
                this.newNotificatins = response.data.data.newNotificatins;
            });
        },
        searchEmployee() {
            this.searchResult = {};
            if (this.search != "") {
                axios({
                    method: "post",
                    url: `/api/admin/search`,
                    data: { search: this.search },
                }).then((response) => {
                    if (Object.keys(response.data.data).length > 0) {
                        this.emptyState = true;
                        this.searchResult = response.data.data;
                    } else {
                        this.emptyState = false;
                    }
                }, (error) => {
                    console.log(error)
                });
            } else {
                this.emptyState = false;
            }
        },
        getProfileImage(src){
          return src.image;
        },
        editCurrentAdmin() {
            axios.get(`/api/admin/profile`).then(response => {
                this.authenticatedAdmin.fill(response.data.data);
                $("#manageCurrentAdminModalUpdate").modal("show");
            });
        },
        updateCurrentAdmin() {
            let formData = new FormData($("#manageAdminFormUpdate")[0]);
            formData.append("token", localStorage.getItem("admin_auth"));
            axios({
                method: "post",
                url: "/api/admin/update-profile",
                data: formData
            }).then((response) => {
                if (response.data.status) {
                    $("#manageCurrentAdminModalUpdate").modal("hide");                    
                    this.$root.adminInfo = response.data.data;
                    this.$root.package_name = response.data.data.package_name;
                    this.$root.packageInfo = response.data.data.subscription_detail;
                    Toast.fire({ icon: 'success', title: response.data.message });
                    this.errors = false;
                } else {
                    this.errors = response.data.message;
                }
            }, (error) => {
                console.log(error)
            });
        }
    },
    components: {
        FormError
    }
}

</script>